export const version = 'v1.0.1';
export const downloads = [
  {
    platform: 'downloads.skywire.windows',
    icon: 'windows',
    mobile: false,
    builds: [{
      name: 'downloads.skywire.installer',
      architectures: [{
        name: '64bit',
        download: 'https://downloads.skycoin.com/skywire/skywire-installer-v1.2.1-windows-amd64.msi',
        filetype: '.msi',
        filesize: '16.4mb',
      }],
    }, {
      name: 'downloads.skywire.installer',
      architectures: [{
        name: '32bit',
        download: 'https://downloads.skycoin.com/skywire/skywire-installer-v1.2.1-windows-386.msi',
        filetype: '.msi',
        filesize: '16.1mb',
      }],
    }],
  },
  {
    platform: 'downloads.skywire.macos',
    icon: 'macos',
    mobile: false,
    builds: [{
      name: 'downloads.skywire.installer',
      architectures: [{
        name: '64bit (x64)',
        download: 'https://downloads.skycoin.com/skywire/skywire-installer-v1.2.1-darwin-amd64.pkg',
        filetype: '.pkg',
        filesize: '33.7mb',
      }],
    }, {
      name: 'downloads.skywire.installer',
      architectures: [{
        name: '64bit (arm)',
        download: 'https://downloads.skycoin.com/skywire/skywire-installer-v1.2.1-darwin-arm64.pkg',
        filetype: '.pkg',
        filesize: '32.8mb',
      }],
    }],
  },
  {
    platform: 'downloads.skywire.linux',
    icon: 'linux',
    mobile: false,
    builds: [{
      name: 'downloads.skywire.package',
      architectures: [{
        name: '',
        download: 'https://github.com/skycoin/skywire/wiki/Skywire-Package-Installation',
        downloadIsInfo: true,
        filetype: '',
        filesize: '',
      }],
    }],
  },
];



// WEBPACK FOOTER //
// ./src/components/Downloads/components/SkywirePackages/downloads.js